module.exports = __webpack_public_path__ + "img/plumber01.b8738a46.jpg";